import React from 'react';
import { Outlet } from 'react-router-dom';

const GoalStaticsMngPage = () => {
  return <Outlet />;
};

export default GoalStaticsMngPage;
